import { render } from "./PowderReportView.vue?vue&type=template&id=3b7abcfd&scoped=true"
import script from "./PowderReportView.vue?vue&type=script&lang=js"
export * from "./PowderReportView.vue?vue&type=script&lang=js"

import "./PowderReportView.vue?vue&type=style&index=0&id=3b7abcfd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7abcfd"]])

export default __exports__